var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "newsletter-widget" }, [
    _c(
      "form",
      {
        attrs: { id: "newsletter-input-form_" + _vm._uid, method: "post" },
        on: {
          submit: function($event) {
            $event.preventDefault()
            return _vm.validateData.apply(null, arguments)
          }
        }
      },
      [
        _c("div", { staticClass: "row" }, [
          _c("div", { staticClass: "col-12 col-md-6" }, [
            _c("div", {
              staticClass: "newsletter-widget__text",
              domProps: { innerHTML: _vm._s(_vm.text) }
            })
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "col-12 col-md-6" }, [
            _c("div", { staticClass: "row" }, [
              _vm.showNameInputs
                ? _c("div", { staticClass: "col-12 col-md-6 col-xl-3" }, [
                    _c("div", { staticClass: "input-unit" }, [
                      _c(
                        "label",
                        { attrs: { for: "first-name-input_" + _vm._uid } },
                        [
                          _vm._v(
                            _vm._s(
                              _vm.$translate(
                                "Ceres::Template.newsletterFirstName"
                              )
                            )
                          )
                        ]
                      ),
                      _vm._v(" "),
                      _c("input", {
                        directives: [
                          {
                            name: "model",
                            rawName: "v-model",
                            value: _vm.firstName,
                            expression: "firstName"
                          }
                        ],
                        attrs: {
                          type: "text",
                          id: "first-name-input_" + _vm._uid
                        },
                        domProps: { value: _vm.firstName },
                        on: {
                          input: function($event) {
                            if ($event.target.composing) {
                              return
                            }
                            _vm.firstName = $event.target.value
                          }
                        }
                      })
                    ])
                  ])
                : _vm._e(),
              _vm._v(" "),
              _vm.showNameInputs
                ? _c("div", { staticClass: "col-12 col-md-6 col-xl-3" }, [
                    _c("div", { staticClass: "input-unit" }, [
                      _c(
                        "label",
                        { attrs: { for: "last-name-input_" + _vm._uid } },
                        [
                          _vm._v(
                            _vm._s(
                              _vm.$translate(
                                "Ceres::Template.newsletterLastName"
                              )
                            )
                          )
                        ]
                      ),
                      _vm._v(" "),
                      _c("input", {
                        directives: [
                          {
                            name: "model",
                            rawName: "v-model",
                            value: _vm.lastName,
                            expression: "lastName"
                          }
                        ],
                        attrs: {
                          type: "text",
                          id: "last-name-input_" + _vm._uid
                        },
                        domProps: { value: _vm.lastName },
                        on: {
                          input: function($event) {
                            if ($event.target.composing) {
                              return
                            }
                            _vm.lastName = $event.target.value
                          }
                        }
                      })
                    ])
                  ])
                : _vm._e(),
              _vm._v(" "),
              _c("div", { staticClass: "col-12 col-md-7 col-xl-3" }, [
                _c("div", { staticClass: "input-group" }, [
                  _c(
                    "div",
                    {
                      staticClass: "input-unit",
                      attrs: { "data-validate": "mail" }
                    },
                    [
                      _c(
                        "label",
                        { attrs: { for: "email-input-id_" + _vm._uid } },
                        [
                          _vm._v(
                            _vm._s(
                              _vm.$translate("Ceres::Template.newsletterEmail")
                            ) + " *"
                          )
                        ]
                      ),
                      _vm._v(" "),
                      _c("input", {
                        directives: [
                          {
                            name: "model",
                            rawName: "v-model",
                            value: _vm.email,
                            expression: "email"
                          }
                        ],
                        attrs: {
                          type: "email",
                          autocomplete: "email",
                          id: "email-input-id_" + _vm._uid
                        },
                        domProps: { value: _vm.email },
                        on: {
                          focus: function($event) {
                            _vm.loadRecaptcha = true
                          },
                          input: function($event) {
                            if ($event.target.composing) {
                              return
                            }
                            _vm.email = $event.target.value
                          }
                        }
                      })
                    ]
                  ),
                  _vm._v(" "),
                  _c("input", {
                    directives: [
                      {
                        name: "model",
                        rawName: "v-model",
                        value: _vm.honeypot,
                        expression: "honeypot"
                      }
                    ],
                    staticClass: "honey",
                    attrs: {
                      autocomplete: "none",
                      type: "text",
                      name: "username",
                      tabindex: "-1"
                    },
                    domProps: { value: _vm.honeypot },
                    on: {
                      input: function($event) {
                        if ($event.target.composing) {
                          return
                        }
                        _vm.honeypot = $event.target.value
                      }
                    }
                  })
                ])
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "col-12 col-md-5 col-xl-3" }, [
                _c("div", { staticClass: "input-group-btn" }, [
                  _c(
                    "button",
                    {
                      staticClass: "btn btn-block btn-primary btn-appearance",
                      class: _vm.buttonSizeClass,
                      attrs: { type: "button", disabled: _vm.isDisabled },
                      on: { click: _vm.validateData }
                    },
                    [
                      _c("icon", {
                        attrs: {
                          icon: "paper-plane-o",
                          loading: _vm.isDisabled
                        }
                      }),
                      _vm._v(
                        "\n                                " +
                          _vm._s(
                            _vm.$translate(
                              "Ceres::Template.newsletterSubscribeButtonLabel"
                            )
                          ) +
                          "\n                            "
                      )
                    ],
                    1
                  )
                ])
              ]),
              _vm._v(" "),
              _vm.showPrivacyPolicyCheckbox
                ? _c("div", { staticClass: "col-12" }, [
                    _c(
                      "div",
                      {
                        staticClass: "form-check small",
                        attrs: { "data-validate": "" }
                      },
                      [
                        _c("input", {
                          directives: [
                            {
                              name: "model",
                              rawName: "v-model",
                              value: _vm.privacyPolicyValue,
                              expression: "privacyPolicyValue"
                            }
                          ],
                          staticClass: "form-check-input",
                          attrs: {
                            type: "checkbox",
                            id: "privacy-policy-accept-id_" + _vm._uid,
                            name: "privacy-policy-accept"
                          },
                          domProps: {
                            checked: Array.isArray(_vm.privacyPolicyValue)
                              ? _vm._i(_vm.privacyPolicyValue, null) > -1
                              : _vm.privacyPolicyValue
                          },
                          on: {
                            change: function($event) {
                              var $$a = _vm.privacyPolicyValue,
                                $$el = $event.target,
                                $$c = $$el.checked ? true : false
                              if (Array.isArray($$a)) {
                                var $$v = null,
                                  $$i = _vm._i($$a, $$v)
                                if ($$el.checked) {
                                  $$i < 0 &&
                                    (_vm.privacyPolicyValue = $$a.concat([$$v]))
                                } else {
                                  $$i > -1 &&
                                    (_vm.privacyPolicyValue = $$a
                                      .slice(0, $$i)
                                      .concat($$a.slice($$i + 1)))
                                }
                              } else {
                                _vm.privacyPolicyValue = $$c
                              }
                            }
                          }
                        }),
                        _vm._v(" "),
                        _c("label", {
                          staticClass: "form-check-label",
                          attrs: {
                            for: "privacy-policy-accept-id_" + _vm._uid
                          },
                          domProps: { innerHTML: _vm._s(_vm.privacyPolicyText) }
                        })
                      ]
                    )
                  ])
                : _vm._e()
            ])
          ])
        ]),
        _vm._v(" "),
        !!_vm.$ceres.config.global.googleRecaptchaApiKey && _vm.loadRecaptcha
          ? _c("recaptcha")
          : _vm._e()
      ],
      1
    )
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }